/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="30" height="30" viewBox="0 0 30 30" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g>
          <polygon points="0 0 30 0 30 30 0 30 0 0" style={{
            fill: '#fff',
            fillRule: 'evenodd',
          }}/>
          <path d="M22.45,18.09a5.45,5.45,0,0,1-.34,1.82,3.61,3.61,0,0,1-.87,1.33,3.82,3.82,0,0,1-1.33.87,5.45,5.45,0,0,1-1.82.34c-.8,0-1.05.05-3.09.05s-2.29,0-3.09-.05a5.45,5.45,0,0,1-1.82-.34,3.88,3.88,0,0,1-2.2-2.2,5.69,5.69,0,0,1-.35-1.82c0-.8,0-1.05,0-3.09s0-2.29,0-3.09a5.69,5.69,0,0,1,.35-1.82,3.82,3.82,0,0,1,.87-1.33,3.73,3.73,0,0,1,1.33-.87,5.45,5.45,0,0,1,1.82-.34c.8,0,1.05,0,3.09,0s2.29,0,3.09,0a5.45,5.45,0,0,1,1.82.34,3.82,3.82,0,0,1,1.33.87,3.69,3.69,0,0,1,.87,1.33,5.45,5.45,0,0,1,.34,1.82c0,.8.05,1.05.05,3.09s0,2.29-.05,3.09M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0" transform="translate(0 0)" style={{ fillRule: 'evenodd' }} className="icon-fill"/>
        </g><path d="M19,11.9a.9.9,0,0,1,0-1.8.9.9,0,1,1,0,1.8m-4,7A3.85,3.85,0,1,1,18.85,15,3.85,3.85,0,0,1,15,18.85m5.85-8.27a2.44,2.44,0,0,0-1.43-1.43A4.15,4.15,0,0,0,18,8.9c-.79,0-1-.05-3-.05s-2.24,0-3,.05a4.15,4.15,0,0,0-1.39.25,2.44,2.44,0,0,0-1.43,1.43A4.35,4.35,0,0,0,8.89,12c0,.79,0,1,0,3s0,2.24,0,3a4.35,4.35,0,0,0,.26,1.39,2.44,2.44,0,0,0,1.43,1.43A4.15,4.15,0,0,0,12,21.1c.79,0,1,0,3,0s2.24,0,3,0a4.15,4.15,0,0,0,1.39-.25,2.44,2.44,0,0,0,1.43-1.43A4.15,4.15,0,0,0,21.1,18c0-.79,0-1,0-3s0-2.24,0-3a4.15,4.15,0,0,0-.25-1.39" transform="translate(0 0)" style={{ fillRule: 'evenodd' }} className="icon-fill"/><path d="M15,12.5A2.5,2.5,0,1,0,17.5,15,2.5,2.5,0,0,0,15,12.5" transform="translate(0 0)" style={{ fillRule: 'evenodd' }} className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'InstagramIcon';

export default Icon;
